import React from "react";
import { Container } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import img1 from "../../assets/images/carrer_img-768x768.webp";

const Apply = () => {
  return (
    <div>
      <section className="contact-hero">
        <Container>
          <h1>Apply</h1>
          <p>
            <NavLink to="/">Home</NavLink> <span>»</span> Apply
          </p>
        </Container>
      </section>
      <div className="container">
        <div className="row">
          <div className="col-md-4 mt-5 mb-4 text-center">
            <h5 className="mt-5">Careers</h5>
            <p>Join Our Team and Shape the Future of Technology</p>
            <img src={img1} className="w-100 h-50 rounded" />
          </div>
          <div className="col-md-8">
            <div className="apply-form-card mt-5 mb-4">
              <form>
                <div className="row">
                  <div className="col-md-6 mb-3">
                    <input
                      type="text"
                      className="form-control custom-input"
                      placeholder="Enter Your Name"
                    />
                  </div>

                  <div className="col-md-6 mb-3">
                    <input
                      type="email"
                      className="form-control custom-input"
                      placeholder="Email Address"
                    />
                  </div>

                  <div className="col-md-6 mb-3">
                    <input
                      type="tel"
                      className="form-control custom-input"
                      placeholder="Phone Number"
                    />
                  </div>

                  <div className="col-md-6 mb-3">
                    <select className="form-control custom-input">
                      <option value="">Domain</option>
                      <option>MERN Stack</option>
                      <option>Frontend</option>
                      <option>Backend</option>
                      <option>Full Stack</option>
                    </select>
                  </div>

                  <div className="col-md-6 mb-3">
                    <select className="form-control custom-input">
                      <option value="">Total Years of Experience</option>
                      <option>0–1</option>
                      <option>1–3</option>
                      <option>3–5</option>
                      <option>5+</option>
                    </select>
                  </div>

                  <div className="col-md-6 mb-3">
                    <select className="form-control custom-input">
                      <option value="">Relevant Experience</option>
                      <option>Yes</option>
                      <option>No</option>
                    </select>
                  </div>

                  <div className="col-md-6 mb-3">
                    <input
                      type="date"
                      className="form-control custom-input"
                      placeholder="Last Working Day"
                    />
                  </div>

                  <div className="col-md-6 mb-3">
                    <input type="file" className="form-control custom-input" />
                  </div>

                  <div className="col-md-12 mb-3">
                    <textarea
                      className="form-control custom-input"
                      placeholder="Your Message"
                    ></textarea>
                  </div>

                  <div className="col-md-12 text-end">
                    <button type="submit" className="btn apply-btn">
                      SEND MESSAGE →
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Apply;
